exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.Qp9Ao{cursor:pointer;font-size:14px;margin:0 4px}span._3WQPc{font-size:16px;margin:0 8px}._2TG6G,.JTcPi{background:#f3d8d8}.jQMgb{background:#d8e6f3}.wRb9f{padding:0!important}._3dhLc{padding:7px 3px}._2q2eR div{overflow-x:hidden!important}._2q2eR div div div div{overflow:hidden!important}", ""]);

// exports
exports.locals = {
	"btn": "Qp9Ao",
	"info": "_3WQPc",
	"sinAcceso": "_2TG6G",
	"eliminado": "JTcPi",
	"totalPass": "jQMgb",
	"tdClear": "wRb9f",
	"field": "_3dhLc",
	"hidden": "_2q2eR"
};